import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DepartamentoSerie } from '../model/departamento-serie';

@Injectable()
export class DepartamentosSeriesService {
  constructor(
    private http: HttpClient
  ) { }

  private API_DEPARTAMENTOS_SERIES = environment.API_BASE + '/Series/Client/';

  // getDepartamentosSeriesByClient(clientId: number, userId?: number): Observable<DepartamentoSerie[]> {
  //   return this.http.get<DepartamentoSerie[]>(`${this.API_DEPARTAMENTOS_SERIES}${clientId}/${userId || ''}`)
  //     .pipe(map((departamentosSeries: DepartamentoSerie[]) => departamentosSeries
  //       .map((departamentoSerie: DepartamentoSerie) => DepartamentoSerie.toModel(JSON.stringify(departamentoSerie)))));
  // }

  getDepartamentosSeriesByClient(clientId: number, userId?: number, onlyInventario: boolean = false): Observable<DepartamentoSerie[]> {
    return this.http.get<DepartamentoSerie[]>(`${this.API_DEPARTAMENTOS_SERIES}GetSeriesCliente?` +
      `idClient=${clientId}&IdUser=${userId}&onlyInventario=${onlyInventario}&paraCargar=${onlyInventario}`)
      .pipe(map((departamentosSeries: DepartamentoSerie[]) => departamentosSeries
        .map((departamentoSerie: DepartamentoSerie) => DepartamentoSerie.toModel(JSON.stringify(departamentoSerie)))));
  }

}
